import type { Role } from '@/features/hierarchy/hierarchy'

export type Sport =
  | 'Cricket'
  | 'Soccer'
  | 'Tennis'
  | 'Horse Racing'
  | 'Greyhound Racing'
  | 'Casino'

export const SPORTS: Sport[] = [
  'Cricket',
  'Soccer',
  'Tennis',
  'Horse Racing',
  'Greyhound Racing',
  'Casino',
]

export type GameBucket =
  | 'SportsBook'
  | 'SportsBook - Bookmaker'
  | 'Fancy'
  | 'Racing'
  | 'Live Casino'
  | 'Crash Game'
  | 'Card Game'
  | 'Credit Limit'

export const GAME_FILTERS: GameBucket[] = [
  'SportsBook',
  'SportsBook - Bookmaker',
  'Fancy',
  'Racing',
  'Live Casino',
  'Crash Game',
  'Card Game',
]

/**
 * Lab PL Statement “Select Type” → `Account/getDownlineAccountsData` `typeName`.
 * Same static list as project Backend-UI `PLStatementCtrl.getTypes`.
 * `Linesession` → Agent/CM-API `is_line_session = true` (Betfair line session).
 */
export type PlTypeName =
  | 'Match Odds'
  | 'Completed Match'
  | 'Tied Match'
  | 'Bookmaker'
  | 'Session'
  | 'Linesession'

export const TYPE_FILTERS: PlTypeName[] = [
  'Match Odds',
  'Completed Match',
  'Tied Match',
  'Bookmaker',
  'Session',
  'Linesession',
]

/** Dropdown / chip labels — API value stays Lab `typeName` (e.g. Linesession). */
export const PL_TYPE_LABEL: Record<PlTypeName, string> = {
  'Match Odds': 'Match Odds',
  'Completed Match': 'Completed Match',
  'Tied Match': 'Tied Match',
  Bookmaker: 'Bookmaker',
  Session: 'Session',
  Linesession: 'Betfair Line Session',
}

export const SPORT_FILTERS: Sport[] = ['Cricket', 'Soccer', 'Tennis']

export interface DateRange {
  from: string
  to: string
}

export interface PnlRow {
  id: string
  settledAt: string
  memberId: string
  sport: Sport
  game: GameBucket
  marketId?: string
  eventId: string
  eventName: string
  marketName: string
  memberPnl: number
  commission: number
  netAmount: number
  split: Partial<Record<Role, number>>
  betCount: number
  turnover: number
  /** Member settlement currency (INR / POINTS) — drives ₹ vs Pts display. */
  currencyType?: string
  /** Lab Invalidate P&L original row — still listed (unlike Invalid Bets). */
  isPNLInvalid?: boolean
  /** Lab Invalidate P&L reverse row — still listed. */
  isPNLRollBack?: boolean
  /** Lab Invalid Bets — Account Statement Status / event prefix. */
  isInvalid?: boolean
  isRollback?: boolean
}

/** Scope tree / banner account — adapted from hierarchy nodes. */
export interface ReportAccount {
  id: string
  username: string
  displayName: string
  role: Role
  parentId: string | null
  path: string[]
  memberCount: number
}

export function isAgent(role: Role): boolean {
  return role !== 'player'
}
